/**
 * Created by ZhangJunPeng on 2017/5/22.
 */
import React from 'react';
import { connect } from 'dva';
import { LocaleProvider } from 'antd';
import { IntlProvider } from 'react-intl';

import enUS from 'antd/lib/locale-provider/en_US';

const App = ({ children, i18n }) => {
  const { locale, messages } = i18n;
  return (
    <IntlProvider locale={locale} messages={messages}>
      <LocaleProvider locale={locale === 'en_US' ? enUS : null}>
        {children}
      </LocaleProvider>
    </IntlProvider>
  );
};

export default connect(state => state)(App);



// WEBPACK FOOTER //
// ./src/routes/App.js